import { USER_IDS } from "common/constants/userIds";

export const checkIsMapsClient = (userId?: any) => (
  userId === USER_IDS.mapsClient
);
